(() => {
  const bound = new WeakSet();

  function initFaq(root) {
    if (!root || bound.has(root)) return;
    bound.add(root);

    const items = [...root.querySelectorAll('[data-faq-item]')];
    if (!items.length) return;

    const openFirst = root.dataset.openFirst !== 'false';
    let openIndex = openFirst ? 0 : -1;

    const setOpen = (index) => {
      openIndex = index;
      items.forEach((item, i) => {
        const isOpen = i === openIndex;
        item.classList.toggle('open', isOpen);

        const trigger = item.querySelector('[data-faq-trigger]');
        const icon = item.querySelector('.faq-icon');
        const chevron = item.querySelector('.faq-chevron');

        if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (icon) icon.classList.toggle('active', isOpen);
        if (chevron) chevron.classList.toggle('open', isOpen);
      });
    };

    items.forEach((item, index) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        setOpen(openIndex === index ? -1 : index);
        // Closing a long answer above pulls the page up; keep this question on screen.
        if (window.BzScroll) window.BzScroll.keepInView(item);
      });
    });

    setOpen(openIndex);
  }

  function boot(scope = document) {
    scope.querySelectorAll('[data-bz-faq-section]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
